import React, { FC } from 'react'
import { useCarrierMembershipApi } from 'apps/fleet-planner/hooks/useCarrierMembershipApi'
import { IMotorCarrier } from 'apps/fleet-planner/types'
import { ConfirmationModal, ToastState } from 'transfix-ui'

interface IRemoveCarrierModalProps {
  motorCarrier?: IMotorCarrier
  onSuccess: (toastState: Omit<ToastState, 'toastOpen'>) => void
  onClose: () => void
}

export const RemoveCarrierModal: FC<IRemoveCarrierModalProps> = ({
  motorCarrier,
  onClose,
  onSuccess,
}) => {
  const { removeMotorCarrier } = useCarrierMembershipApi()
  const confirmHandler = () => {
    if (motorCarrier) {
      removeMotorCarrier(motorCarrier.id).then(() => {
        const toastMessage = 'Carrier Removed.'
        onSuccess({
          toastType: 'default',
          toastMessage,
        })
        onClose()
      })
    }
  }
  return (
    <ConfirmationModal
      title={`Remove ${motorCarrier?.legalName}?`}
      size={4}
      open={!!motorCarrier}
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Remove Carrier',
          type: 'confirm',
          action: confirmHandler,
        },
      ]}
      onClose={onClose}>
      You will no longer be able to view this carrier&apos;s loads or create new loads for this
      carrier.
    </ConfirmationModal>
  )
}
